import { normalizeSort } from '../utils'
import UserService from '../services/UserService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['username'],
    sortDesc: [false]
  }
})

const getters = {
  USERS: state => {
    return state.list
  },
  USERS_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_USERS: (state, payload) => {
    state.list = payload
  },
  SET_USERS_PAG: (state, payload) => {
    state.pagination = payload
  },
  DELETE_USER: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ENABLE_USER: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_USER: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_USER: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_USERS: async ({ commit, state, rootGetters }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }
      let response
      const userRoles = rootGetters.CURRENT_USER_ROLES || []
      if (userRoles.includes('admin')) {
        response = await UserService.getManager({ ...currentFilter, ...pagination })
      } else {
        response = await UserService.get({ ...currentFilter, ...pagination })
      }

      let { data, status } = response
      if (status === 200) {
        commit('SET_USERS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de usuarios')
      console.error(error)
    }
  },
  LOAD_ADMINS: async ({ commit, state, rootGetters }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }
      let response
      const userRoles = rootGetters.CURRENT_USER_ROLES || []
      if (userRoles.includes('admin')) {
        response = await UserService.getAdmins({ ...currentFilter, ...pagination })
      } else {
        response = await UserService.get({ ...currentFilter, ...pagination })
      }

      let { data, status } = response
      if (status === 200) {
        commit('SET_USERS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de usuarios')
      console.error(error)
    }
  },
  VIEW_USER: async (obj, params) => {
    try {
      let { data, status } = await UserService.view(params)
      if (status === 200) {
        return data.data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles del usuario')
    }
  },
  ADD_USER: async ({ commit, rootGetters }, payload) => {
    try {
      let response
      const userRoles = rootGetters.CURRENT_USER_ROLES || []
      if (userRoles.includes('admin')) {
        response = await UserService.postManager(payload)
      } else {
        response = await UserService.post(payload)
      }
      let { data, status } = response
      if (status === 201) {
        commit('ADD_USER', data)
        window.app.$toast.success('El usuario ha sido registrado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  UPDATE_USER: async ({ commit }, payload) => {
    try {
      let { data, status } = await UserService.put(payload)
      if (status === 200) {
        commit('UPDATE_USER', data)
        window.app.$toast.success('El usuario ha sido actualizado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  DELETE_USER: async ({ commit }, payload) => {
    try {
      let { status } = await UserService.delete(payload)
      if (status === 204) {
        commit('DELETE_USER', payload)
        window.app.$toast.success('El usuario ha sido deshabilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar deshabilitar el usuario')
    }
  },
  ENABLE_USER: async ({ commit }, payload) => {
    try {
      let { status } = await UserService.enable(payload)
      if (status === 204) {
        commit('ENABLE_USER', payload)
        window.app.$toast.success('El usuario ha sido habilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar habilitar el usuario')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
